export default __webpack_public_path__ + "static/media/user-icon.85ac7c36.svg";